import { useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminEmailUpdate() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const updateEmail = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      const response = await axios.post(`${API}/admin/update-coach-email`, {
        old_email: "klbhealthacademy@gmail.com",
        new_email: "getmealguide@gmail.com",
        admin_key: "emergent-admin-2024"
      });
      
      setResult(response.data);
      
      if (response.data.success) {
        toast.success('✅ Email updated successfully!');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Update error:', error);
      setResult({ 
        success: false, 
        message: error.response?.data?.detail || error.message 
      });
      toast.error('Failed to update email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl text-center">Admin: Update Coach Email</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm">
            <p className="font-semibold mb-2">This will update:</p>
            <p className="text-gray-700">
              From: <span className="font-mono">klbhealthacademy@gmail.com</span>
            </p>
            <p className="text-gray-700">
              To: <span className="font-mono text-green-600">getmealguide@gmail.com</span>
            </p>
            <p className="text-gray-700 mt-2">
              Password remains: <span className="font-mono">111111</span>
            </p>
          </div>

          <Button 
            onClick={updateEmail}
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700"
            size="lg"
          >
            {loading ? 'Updating...' : 'Update Coach Email Now'}
          </Button>

          {result && (
            <div className={`p-4 rounded-lg border ${
              result.success 
                ? 'bg-green-50 border-green-200' 
                : 'bg-red-50 border-red-200'
            }`}>
              <p className={`text-sm font-semibold ${
                result.success ? 'text-green-900' : 'text-red-900'
              }`}>
                {result.success ? '✅ Success!' : '❌ Error'}
              </p>
              <p className={`text-sm mt-1 ${
                result.success ? 'text-green-800' : 'text-red-800'
              }`}>
                {result.message}
              </p>
              {result.matched !== undefined && (
                <p className="text-xs mt-2 text-gray-600">
                  Matched: {result.matched} | Modified: {result.modified}
                </p>
              )}
            </div>
          )}

          {result?.success && (
            <div className="bg-green-100 border border-green-300 rounded-lg p-4">
              <p className="text-sm font-semibold text-green-900 mb-2">
                ✅ Done! You can now log in with:
              </p>
              <div className="text-sm text-green-800 space-y-1">
                <p>📧 Email: <span className="font-mono">getmealguide@gmail.com</span></p>
                <p>🔑 Password: <span className="font-mono">111111</span></p>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
